import { Component, inject, OnInit, Type, ViewContainerRef, ViewChild, ComponentRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Route } from '@angular/router';
import { WelcomeComponent } from '../../welcome/welcome.component';
import { InsuranceInformationComponent } from '../../disclaimer/insurance-information/insurance-information.component';
import { ClaimReportDutyInformationComponent } from '../../disclaimer/claim-report-duty-information/claim-report-duty-information.component';
import { ImportanceOfQuickResponseComponent } from '../../disclaimer/importance-of-quick-response/importance-of-quick-response.component';
import { WhatIsCoveredComponent } from '../../disclaimer/what-is-covered/what-is-covered.component';
import { UserParticipationIdentificationComponent } from '../../accident-report/user-participation-identification/user-participation-identification.component';
import { MultiplePartyInvolvementCheckComponent } from '../../accident-report/multiple-party-involvement-check/multiple-party-involvement-check.component';
import { EnterLicensePlateComponent } from '../../accident-report/enter-license-plate/enter-license-plate.component';
import { NoProcessingPossibleComponent } from '../../accident-report/no-processing-possible/no-processing-possible.component';
import { AccidentLocationComponent } from '../../accident-report/accident-location/accident-location.component';
import { DamageTypeComponent } from '../../accident-report/damage-type/damage-type.component';
import { AccidentRoleComponent } from '../../accident-report/accident-role/accident-role.component';
import { VehicleInvolvedComponent } from '../../accident-report/vehicle-involved/vehicle-involved.component';
import { VehicleAccidentStatusComponent } from '../../accident-report/vehicle-accident-status/vehicle-accident-status.component';
import { CarPartsBeingInvolvedComponent } from '../../accident-report/car-parts-being-invovled/car-parts-being-involved.component';
import { IncidentDescriptionComponent } from '../../accident-report/bodily-injured-accident-description-list/incident-description.component';
import { DetailAccidentDescriptionComponent } from '../../accident-report/detail-accident-description/detail-accident-description.component';
import { AccidentReportFinishedComponent } from '../../accident-report/accident-report-finished/accident-report-finished.component';
import { RideReasonComponent } from '../../ride-information/ride-reason/ride-reason.component';
import { DriverAgeComponent } from '../../ride-information/driver-age/driver-age.component';
import { ActiveRideComponent } from '../../ride-information/active-ride/active-ride.component';
import { AlcoholConsumptionComponent } from '../../ride-information/alcohol-consumption/alcohol-consumption.component';
import { PoliceReportComponent } from '../../ride-information/police-report/police-report.component';
import { PolicePreformedDrugTestComponent } from '../../ride-information/police-preformed-drug-test/police-preformed-drug-test.component';
import { WitnessInformationComponent } from '../../ride-information/witness-information/witness-information.component';
import { WitnessInformationRedirectComponent } from '../../ride-information/witness-information-redirect/witness-information-redirect.component';
import { PotentialTechnicalDefectComponent } from '../../ride-information/potential-technical-defect/potential-technical-defect.component';
import { PotentialTechnicalDefectRedirectComponent } from '../../ride-information/potential-technical-defect-redirect/potential-technical-defect-redirect.component';
import { FaultAllocationComponent } from '../../ride-information/fault-allocation/fault-allocation.component';
import { ThirdPartyContactInformationComponent } from '../../ride-information/third-party-contact-information/third-party-contact-information.component';
import { RideInformationFinishedComponent } from '../../ride-information/ride-information-finished/ride-information-finished.component';
import { DocumentUploadOverviewComponent } from '../../document-upload/document-upload-overview/document-upload-overview.component';
import { DocumentUploadPoliceReportComponent } from '../../document-upload/document-upload-police-report/document-upload-police-report.component';
import { DocumentUploadFinishedComponent } from '../../document-upload/document-upload-finished/document-upload-finished.component';
import { PersonalInformationComponent } from '../../personal-information/personal-information/personal-information.component';
import { PersonalInformationFinishedComponent } from '../../personal-information/personal-information-finished/personal-information-finished.component';
import { DataIsCorrectComponent } from '../../data-is-correct/data-is-correct/data-is-correct.component';
import { OverviewComponent } from '../../overview/overview/overview.component';
import { WhatToDoComponent } from '../../information-pages/what-to-do/what-to-do.component';
import { AboutInsurerComponent } from '../../information-pages/about-insurer/about-insurer.component';
import { AboutPolicyholderComponent } from '../../information-pages/about-policyholder/about-policyholder.component';
import { ImprintComponent } from '../../information-pages/imprint/imprint.component';
import { DataPrivacyComponent } from '../../information-pages/data-privacy/data-privacy.component';
import { FaqComponent } from '../../information-pages/faq/faq.component';
import { ContactValidationComponent } from '../../overview/contact-validation/contact-validation.component';
import { OverviewFinishedComponent } from '../../overview/overview-finished/overview-finished.component';
import { TokenExpiredRestartComponent } from '../../token-expired/token-expired-restart/token-expired-restart.component';
import { routeKeyMap } from '../../../../routeKeyMap';
import { ClaimsService } from '../../../../services/claims.service';
import { PdfApiService } from '../../../../services/api/pdf-api.service';
import { routes as appRoutes } from '../../../../app.routes';

interface RouteConfig {
  routeName: string;
  componentName: string;
  componentSelector: string;
  requiresData: boolean;
}

interface ComponentMetadata {
  name: string;
  selector: string;
}

const COMPONENT_METADATA_MAP = new Map<Type<any>, ComponentMetadata>([
  [WelcomeComponent, { name: 'WelcomeComponent', selector: 'app-welcome' }],
  [InsuranceInformationComponent, { name: 'InsuranceInformationComponent', selector: 'app-insurance-information' }],
  [ClaimReportDutyInformationComponent, { name: 'ClaimReportDutyInformationComponent', selector: 'app-claim-report-duty-information' }],
  [ImportanceOfQuickResponseComponent, { name: 'ImportanceOfQuickResponseComponent', selector: 'app-importance-of-quick-response' }],
  [WhatIsCoveredComponent, { name: 'WhatIsCoveredComponent', selector: 'app-what-is-covered' }],
  [UserParticipationIdentificationComponent, { name: 'UserParticipationIdentificationComponent', selector: 'app-user-participation-identification' }],
  [MultiplePartyInvolvementCheckComponent, { name: 'MultiplePartyInvolvementCheckComponent', selector: 'app-multiple-party-involvement-check' }],
  [EnterLicensePlateComponent, { name: 'EnterLicensePlateComponent', selector: 'app-enter-license-plate' }],
  [NoProcessingPossibleComponent, { name: 'NoProcessingPossibleComponent', selector: 'app-no-processing-possible' }],
  [AccidentLocationComponent, { name: 'AccidentLocationComponent', selector: 'app-accident-location' }],
  [DamageTypeComponent, { name: 'DamageTypeComponent', selector: 'app-damage-type' }],
  [AccidentRoleComponent, { name: 'AccidentRoleComponent', selector: 'app-accident-role' }],
  [VehicleInvolvedComponent, { name: 'VehicleInvolvedComponent', selector: 'app-vehicle-involved' }],
  [VehicleAccidentStatusComponent, { name: 'VehicleAccidentStatusComponent', selector: 'app-vehicle-accident-status' }],
  [CarPartsBeingInvolvedComponent, { name: 'CarPartsBeingInvolvedComponent', selector: 'app-car-parts-being-involved' }],
  [IncidentDescriptionComponent, { name: 'IncidentDescriptionComponent', selector: 'app-bodily-injured-accident-description-list' }],
  [DetailAccidentDescriptionComponent, { name: 'DetailAccidentDescriptionComponent', selector: 'app-detail-accident-description' }],
  [AccidentReportFinishedComponent, { name: 'AccidentReportFinishedComponent', selector: 'app-accident-report-finished' }],
  [RideReasonComponent, { name: 'RideReasonComponent', selector: 'app-ride-reason' }],
  [DriverAgeComponent, { name: 'DriverAgeComponent', selector: 'app-driver-age' }],
  [ActiveRideComponent, { name: 'ActiveRideComponent', selector: 'app-active-ride' }],
  [AlcoholConsumptionComponent, { name: 'AlcoholConsumptionComponent', selector: 'app-alcohol-consumption' }],
  [PoliceReportComponent, { name: 'PoliceReportComponent', selector: 'app-police-report' }],
  [PolicePreformedDrugTestComponent, { name: 'PolicePreformedDrugTestComponent', selector: 'app-police-preformed-drug-test' }],
  [WitnessInformationComponent, { name: 'WitnessInformationComponent', selector: 'app-witness-information' }],
  [WitnessInformationRedirectComponent, { name: 'WitnessInformationRedirectComponent', selector: 'app-witness-information-redirect' }],
  [PotentialTechnicalDefectComponent, { name: 'PotentialTechnicalDefectComponent', selector: 'app-potential-technical-defect' }],
  [PotentialTechnicalDefectRedirectComponent, { name: 'PotentialTechnicalDefectRedirectComponent', selector: 'app-potential-technical-defect-redirect' }],
  [FaultAllocationComponent, { name: 'FaultAllocationComponent', selector: 'app-fault-allocation' }],
  [ThirdPartyContactInformationComponent, { name: 'ThirdPartyContactInformationComponent', selector: 'app-third-party-contact-information' }],
  [RideInformationFinishedComponent, { name: 'RideInformationFinishedComponent', selector: 'app-ride-information-finished' }],
  [DocumentUploadOverviewComponent, { name: 'DocumentUploadOverviewComponent', selector: 'app-document-upload-overview' }],
  [DocumentUploadPoliceReportComponent, { name: 'DocumentUploadPoliceReportComponent', selector: 'app-document-upload-police-report' }],
  [DocumentUploadFinishedComponent, { name: 'DocumentUploadFinishedComponent', selector: 'app-document-upload-finished' }],
  [PersonalInformationComponent, { name: 'PersonalInformationComponent', selector: 'app-personal-information' }],
  [PersonalInformationFinishedComponent, { name: 'PersonalInformationFinishedComponent', selector: 'app-personal-information-finished' }],
  [DataIsCorrectComponent, { name: 'DataIsCorrectComponent', selector: 'app-data-is-correct' }],
  [OverviewComponent, { name: 'OverviewComponent', selector: 'app-overview' }],
  [WhatToDoComponent, { name: 'WhatToDoComponent', selector: 'app-what-to-do' }],
  [AboutInsurerComponent, { name: 'AboutInsurerComponent', selector: 'app-about-signal-iduna' }],
  [AboutPolicyholderComponent, { name: 'AboutPolicyholderComponent', selector: 'app-about-policyholder' }],
  [ImprintComponent, { name: 'ImprintComponent', selector: 'app-imprint' }],
  [DataPrivacyComponent, { name: 'DataPrivacyComponent', selector: 'app-data-privacy' }],
  [FaqComponent, { name: 'FaqComponent', selector: 'app-faq' }],
  [ContactValidationComponent, { name: 'ContactValidationComponent', selector: 'app-contact-validation' }],
  [OverviewFinishedComponent, { name: 'OverviewFinishedComponent', selector: 'app-overview-finished' }],
  [TokenExpiredRestartComponent, { name: 'TokenExpiredRestartComponent', selector: 'app-token-expired-restart' }],
]);

// Reverse map: selector -> component type
const SELECTOR_TO_COMPONENT_MAP = new Map<string, Type<any>>([
  ['app-welcome', WelcomeComponent],
  ['app-insurance-information', InsuranceInformationComponent],
  ['app-claim-report-duty-information', ClaimReportDutyInformationComponent],
  ['app-importance-of-quick-response', ImportanceOfQuickResponseComponent],
  ['app-what-is-covered', WhatIsCoveredComponent],
  ['app-user-participation-identification', UserParticipationIdentificationComponent],
  ['app-multiple-party-involvement-check', MultiplePartyInvolvementCheckComponent],
  ['app-enter-license-plate', EnterLicensePlateComponent],
  ['app-no-processing-possible', NoProcessingPossibleComponent],
  ['app-accident-location', AccidentLocationComponent],
  ['app-damage-type', DamageTypeComponent],
  ['app-accident-role', AccidentRoleComponent],
  ['app-vehicle-involved', VehicleInvolvedComponent],
  ['app-vehicle-accident-status', VehicleAccidentStatusComponent],
  ['app-car-parts-being-involved', CarPartsBeingInvolvedComponent],
  ['app-bodily-injured-accident-description-list', IncidentDescriptionComponent],
  ['app-detail-accident-description', DetailAccidentDescriptionComponent],
  ['app-accident-report-finished', AccidentReportFinishedComponent],
  ['app-ride-reason', RideReasonComponent],
  ['app-driver-age', DriverAgeComponent],
  ['app-active-ride', ActiveRideComponent],
  ['app-alcohol-consumption', AlcoholConsumptionComponent],
  ['app-police-report', PoliceReportComponent],
  ['app-police-preformed-drug-test', PolicePreformedDrugTestComponent],
  ['app-witness-information', WitnessInformationComponent],
  ['app-witness-information-redirect', WitnessInformationRedirectComponent],
  ['app-potential-technical-defect', PotentialTechnicalDefectComponent],
  ['app-potential-technical-defect-redirect', PotentialTechnicalDefectRedirectComponent],
  ['app-fault-allocation', FaultAllocationComponent],
  ['app-third-party-contact-information', ThirdPartyContactInformationComponent],
  ['app-ride-information-finished', RideInformationFinishedComponent],
  ['app-document-upload-overview', DocumentUploadOverviewComponent],
  ['app-document-upload-police-report', DocumentUploadPoliceReportComponent],
  ['app-document-upload-finished', DocumentUploadFinishedComponent],
  ['app-personal-information', PersonalInformationComponent],
  ['app-personal-information-finished', PersonalInformationFinishedComponent],
  ['app-data-is-correct', DataIsCorrectComponent],
  ['app-overview', OverviewComponent],
  ['app-what-to-do', WhatToDoComponent],
  ['app-about-signal-iduna', AboutInsurerComponent],
  ['app-about-policyholder', AboutPolicyholderComponent],
  ['app-imprint', ImprintComponent],
  ['app-data-privacy', DataPrivacyComponent],
  ['app-faq', FaqComponent],
  ['app-contact-validation', ContactValidationComponent],
  ['app-overview-finished', OverviewFinishedComponent],
  ['app-token-expired-restart', TokenExpiredRestartComponent],
]);

function deriveRoutesFromAppRoutes(): RouteConfig[] {
  const redirectComponents = [
    WitnessInformationRedirectComponent,
    PotentialTechnicalDefectRedirectComponent
  ];

  const result = appRoutes
    .filter((route: Route) =>
      route.component &&
      COMPONENT_METADATA_MAP.has(route.component as Type<any>) &&
      !redirectComponents.includes(route.component as Type<any>)
    )
    .map((route: Route) => {
      const routeName = route.path || 'welcome';
      const component = route.component as Type<any>;
      const metadata = COMPONENT_METADATA_MAP.get(component)!;

      return {
        routeName,
        componentName: metadata.name,
        componentSelector: metadata.selector,
        requiresData: !!routeKeyMap[routeName]
      };
    });
  return result
}

@Component({
  selector: 'app-single-view',
  imports: [CommonModule, RouterLink],
  templateUrl: './single-view.component.html',
  styleUrls: ['./single-view.component.css']
})
export class SingleViewComponent implements OnInit {
  private claimService = inject(ClaimsService);
  private pdfApiService = inject(PdfApiService);

  routeKeyMap = routeKeyMap;
  routes: RouteConfig[] = deriveRoutesFromAppRoutes();
  isGridView = false;
  isGeneratingPdf = false;
  hasLoadedData = false;

  toggleViewMode(): void {
    this.isGridView = !this.isGridView;
  }

  getComponentType(selector: string): Type<any> | null {
    return SELECTOR_TO_COMPONENT_MAP.get(selector) || null;
  }

  public hasData(routeName: string): boolean {
    const key = this.routeKeyMap[routeName];
    // console.log('>>>> _ >>>> ~ single-view.component.ts:29 ~ key:', key)
    if (!key) {
      return false;
    }
    const report = this.claimService.claimReport();
    // console.log('>>>> _ >>>> ~ single-view.component.ts:171 ~ report:', report)
    const value = report?.[key];
    console.log('>>>> _ >>>> ~ single-view.component.ts:34 ~ value:', value)
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return !!value;
  }

  downloadPdf(): void {
    this.isGeneratingPdf = true;

    try {
      this.pdfApiService.downloadPdf('claim-report-single-view.pdf');
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF. Please ensure you are authenticated.');
    } finally {
      // Reset loading state after a delay to allow for download initiation
      setTimeout(() => {
        this.isGeneratingPdf = false;
      }, 2000);
    }
  }

  ngOnInit(){
    this.claimService.getData().subscribe(() => {
      this.hasLoadedData = true
      const reportData = this.claimService.claimReport();
      // console.log('>>>> A >>>> ~ single-view.component.ts:44 ~ reportData:', reportData)
      const key = this.routeKeyMap['user-participation'];
      if (key) {
        this.claimService.claimReport()?.[key];
      }

      // console.log(this.routeKeyMap);
      // const log = this.hasData('user-participation');
      // console.log('>>>> _ >>>> ~ single-view.component.ts:48 ~ log:', log)
    })
  }
}
